import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import { CarrierRate } from './components';

const editForm = ({ match }) => {
  return <CarrierRate telephonyId={match.params._id} />;
};

const routes = () => (
  // <Route exact path="/settings/CarrierRate/:_id" component={CarrierRate} />
  <PrivateRoute
    key="/settings/CarrierRate"
    exact={true}
    path="/settings/CarrierRate/:_id"
    component={editForm}
  />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/CarrierRate/routes.js